// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreSampleOrderSet = (client) => ({
    /**
     * `GET /store/sample-order-set`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListSampleOrderSets
     * @source packages/modules/b2c-core/src/api/store/sample-order-set/route.ts
     */
    list: (query, headers) => client.fetch("/store/sample-order-set", { method: "GET", query, headers }),
    /**
     * `GET /store/sample-order-set/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreRetrieveSampleOrderSet
     * @source packages/modules/b2c-core/src/api/store/sample-order-set/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/sample-order-set/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=sample-order-set.js.map